module.exports = __webpack_public_path__ + "static/img/winterwarriorcollage.ab309a7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/winterwarriorcollage.jpeg
// module id = /Wa9
// module chunks = 0